.wrap {
  position: relative;
  width: 100%;
}

.icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: var(--slate);
  pointer-events: none;
}

.input {
  width: 100%;
  padding: 8px 11px 8px 33px;
  font-size: 13px;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.input:focus {
  border-color: var(--blue);
  outline: none;
}

/* В боковой панели — цвета панели */
.sidebar .icon {
  color: var(--side-muted);
}

.sidebar .input {
  color: var(--side-strong);
  background: var(--side-input-bg);
  border-color: var(--side-input-border);
}

.sidebar .input::placeholder {
  color: var(--side-muted);
}
.sidebar .input:focus {
  border-color: var(--side-active);
}

.drop {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 300;
  width: 440px;
  max-width: calc(100vw - 24px);
  max-height: 70vh;
  overflow-y: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: 0 12px 32px var(--shadow);
}

.popover .drop {
  width: 100%;
}

/* На телефоне список не уходит за нижний край экрана с панелью браузера */
@media (max-width: 699px) {
  .popover .drop {
    max-height: calc(100dvh - 160px);
  }
}

.sectionTitle {
  position: sticky;
  top: 0;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text2);
  /* Заголовок закреплён при прокрутке — фон непрозрачный, иначе в тёмной
     теме под ним просвечивали бы строки */
  background: linear-gradient(var(--table-even), var(--table-even)), var(--card-bg);
  border-bottom: 1px solid var(--border);
}

.item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
}

.item:hover,
.item:focus-visible {
  background: var(--table-hover);
}

.name {
  font-family: var(--mono);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text);
}
.sub {
  font-size: 11px;
  color: var(--text2);
}

.none {
  padding: 9px 12px;
  font-size: 12px;
  color: var(--slate);
}
